const getApplicationSettings = (state, feature) => state.application[feature]

export const getSourcesSettings = state =>
  getApplicationSettings(state, 'workspaceSources')
